/// <reference lib="webworker" />

import { MapFeature } from '../models/map.data';

addEventListener(
  'message',
  ({ data }: { data: { streetFeatures: MapFeature[]; buildingFeatures: MapFeature[] } }) => {
    let min = Number.MAX_SAFE_INTEGER;
    let max = 0;
    const features = data.streetFeatures.concat(data.buildingFeatures);
    if (features.length) {
      features.forEach(f => {
        const price = f.properties?.price || 0;
        if (price < min) {
          min = price;
        }
        if (price > max) {
          max = price;
        }
      });
      postMessage({ min, max });
    } else {
      postMessage({ min: 0, max: 0 });
    }
  }
);
